import { getShuttersClipPaths, getEasing } from '../../utils';
export { initialFrame } from './common';
export function web(options) {
  const [{
    custom,
    ...shuttersIn
  }] = style(options);
  return [{
    ...shuttersIn,
    keyframes: [{
      clipPath: custom['--motion-shutters-start']
    }, {
      clipPath: custom['--motion-shutters-end']
    }]
  }];
}
export function style(options) {
  const {
    direction = 'right',
    shutters = 12,
    staggered = true
  } = options.namedEffect;
  const {
    clipStart,
    clipEnd
  } = getShuttersClipPaths(direction, shutters, staggered);
  const easing = getEasing(options.easing || 'sineIn');
  return [{
    ...options,
    easing,
    name: 'shuttersIn',
    custom: {
      '--motion-shutters-start': clipStart,
      '--motion-shutters-end': clipEnd
    }
  }];
}
//# sourceMappingURL=ShuttersIn.js.map